import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { renderCommand } from './render-command.js';

export const envRemoveCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('remove')
    .description('Removes an environment variable')
    .requiredOption('--key <key>', 'Name of the variable')
    .action(async (opts, command) => {
      const { EnvRemoveCommand } = await import(
        '../components/EnvRemoveCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <EnvRemoveCommand variableKey={opts.key} />
      );
    });
};
